var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 78",
    width: 24,
    height: 24,
    transform: "translate(1105 439)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1105 -439)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1105.223 438.378)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12722",
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10434",
    d: "M20.356,21.244H3.2a2.2,2.2,0,0,1-2.2-2.2V9.073a2.2,2.2,0,0,1,2.2-2.2H6.3l.829-1.658A2.186,2.186,0,0,1,9.1,4h5.36a2.187,2.187,0,0,1,1.965,1.216l.829,1.658h3.105a2.2,2.2,0,0,1,2.2,2.2v9.972a2.2,2.2,0,0,1-2.2,2.2ZM3.2,8.311a.763.763,0,0,0-.762.762v9.972a.763.763,0,0,0,.762.762H20.356a.762.762,0,0,0,.761-.762V9.073a.762.762,0,0,0-.761-.762h-3.55a.719.719,0,0,1-.643-.4L15.137,5.859a.757.757,0,0,0-.679-.422H9.1a.756.756,0,0,0-.679.422L7.391,7.914a.718.718,0,0,1-.643.4Z",
    transform: "translate(-1 -4)",
    fill: "#0c0c0b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12723",
    transform: "translate(7.826 9.748)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10435",
    d: "M14.452,19.9A3.952,3.952,0,1,1,18.4,15.952,3.956,3.956,0,0,1,14.452,19.9Zm0-6.466a2.515,2.515,0,1,0,2.515,2.515A2.518,2.518,0,0,0,14.452,13.437Z",
    transform: "translate(-10.5 -12)",
    fill: "#0c0c0b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.348b50e1.svg";
export { ForwardRef as ReactComponent };